import { render } from "./Question0303.vue?vue&type=template&id=c98ba62e&scoped=true&lang=true"
import script from "./Question0303.vue?vue&type=script&lang=js"
export * from "./Question0303.vue?vue&type=script&lang=js"

import "./Question0303.vue?vue&type=style&index=0&id=c98ba62e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c98ba62e"]])

export default __exports__